import React, { FC } from 'react'

import { styled } from '@linaria/react'

export const FooterPortal: FC = () => {
  return <FooterPortalWrapper id={FOOTER_PORTAL_ID} />
}

const FooterPortalWrapper = styled.div`
  width: 100%;
  margin-top: 1px; /** Чтобы не перекрывало box-shadow */
`

const FOOTER_PORTAL_ID = 'footer-portal-id'

export const findFooterPortalElement = () =>
  document.getElementById(FOOTER_PORTAL_ID)
